<template>
<div class="collapse navbar-collapse" id="collapsibleNavbar">
    
    <ul class="navbar-nav mr-auto" v-if="guest">
        
            <li class="nav-item" >
                <router-link class="nav-link" to="/dashboard/central">Inicio</router-link>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#">Embarcaciones</a>
            </li>
            <li class="nav-item">
                <router-link to="/dashboard/question">Despacho</router-link>
            </li> 
    </ul>

    <ul class="navbar-nav mr-auto" v-if="admin">
        <li class="nav-item">
                <router-link class="nav-link" to="/dashboard/central"><font-awesome-icon icon="home" size="lg" /> </router-link>
            </li>

            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="cog" size="lg" /> Configuracion
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/password">Cambio de Contraseña</router-link>
                    <router-link class="dropdown-item" to="/dashboard/users">Administracion de Usuarios</router-link>

                </div>
            </li>

            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="anchor" size="lg" /> Certificados
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/certificado">Solicitudes de Certificados</router-link>
                    <router-link class="dropdown-item" to="/dashboard/daf">Validacion Depositos</router-link>
                </div>
            </li>   

    </ul>
            

    <ul class="navbar-nav mr-auto" v-if="oper">        
        <li class="nav-item">
                <router-link class="nav-link" to="/dashboard/central"><font-awesome-icon icon="home" size="lg" /> </router-link>
            </li>

            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="cog" size="lg" /> Configuracion
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/password">Cambio de Contraseña</router-link>
                </div>
            </li>

            <li class="nav-item dropdown">
                <a href="#" class="nav-link dropdown-toggle" id="navbardropE" data-toggle="dropdown">
                    <font-awesome-icon icon="anchor" size="lg" /> Certificados
                </a>
                <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/dashboard/certificado">Solicitudes de Certificados</router-link>
                    <router-link class="dropdown-item" to="/dashboard/daf">Validacion Depositos</router-link>

                </div>
            </li>     
    </ul>

    <div class="mt-2 mt-md-0">
        <button class="btn" :class="dangerTime ? 'btn-outline-danger':'btn-outline-success' " @click="mIncrement" > {{ time }} <font-awesome-icon icon="sync-alt" :spin="animate_increment" /> </button>
        <button class="btn btn-outline-primary my-2 my-sm-0" @click="logout2"><font-awesome-icon icon="door-open" size="lg" /> Salir</button>
    </div>

</div>
</template>

<script>
import Vue from 'vue';

export default {
    name:'nav-bar',
    props:{
        guest:Boolean,
        admin:Boolean, 
        oper:Boolean,
        security:Boolean,
        finance:Boolean,
        supadmin:Boolean,
        enrollment:Boolean,
        capitanias:Boolean,
        uumm:Boolean
    },
    mounted(){
        this.mTimeSession()
    },
    data(){
        return {
            time:null,
            dangerTime:false,
            animate_increment:false
        }
    },
    methods:{
        logout2(){
            this.$auth.destroyToken();
            this.$router.push('/auth/login');
            this.$store.dispatch('sessionDestroy',true);
        },
        mTimeSession(){
            
            setInterval(()=>{
                let endToken=localStorage.getItem('authTokenExpiration');
                let timeActually=Date.now();
                let diff=parseInt(endToken)-parseInt(timeActually);
                let min = Math.floor((diff/1000/60) << 0);
                let sec = Math.floor((diff/1000) % 60);
                if(min>0){
                    this.time=`${min + ':' + sec}`;
                }else{
                    this.time=`00:00`;
                }                
                
                if(min<12){
                    this.dangerTime=true;
                }else{
                    this.dangerTime=false;
                }
                // console.log(this.time);
            },1000)
        },
        mIncrement(){
            this.animate_increment=true;
            // console.log('aumentando');
            let endTk=localStorage.getItem('authTokenExpiration');
            let timeActually=Date.now();
            let diff2=parseInt(endTk)-parseInt(timeActually);
            let min = Math.floor((diff2/1000/60) << 0);
            if(min<200){
                let neT=parseInt(endTk)+1800000;
                localStorage.removeItem('authTokenExpiration');
                localStorage.setItem('authTokenExpiration', neT);
            }else{
                toastr.info('Aun cuenta con tiempo suficiente, intentelo dentro 30 min.', 'Advertencia');
            }
            setTimeout(()=>{
                this.animate_increment=false;
            }, 5000)
            // this.$auth.setToken(res.data[0].user[0].api_token, neT, res.data[0].user[0].category,res.data[0].user[0].role );
        }
    },
    computed:{
        cUserSession(){
            // console.log(this.$store.getters.getUserState);
            return this.$store.getters.getUserState;           
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/dashboard/Navbar.vue